import axiosActions from './actions/axiosActions'
import usersActions from './actions/usersActions'
import searchActions from './actions/searchActions'
import selectedProductActions from './actions/selectedProductActions'
import storesActions from './actions/storesActions'
import vouchersActions from './actions/vouchersActions'

export default {
    ...axiosActions,  
    ...usersActions,  
    ...searchActions,  
    ...selectedProductActions,
    ...storesActions,
    ...vouchersActions,
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/actions.js